var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "4 4 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 19.2117V17.3289H16.7391C19.7335 17.3289 20.5501 15.9906 20.5501 14.2439C20.5501 12.5199 19.552 11.1815 17.3289 11.1815C14.7202 11.1815 13.5406 12.5879 13.4499 14.879H11C11.1361 12.293 12.4291 9.25331 17.3289 9.25331C21.3667 9.25331 23 11.431 23 14.0397C23 17.5104 20.3913 19.2117 16.9887 19.2117H15.4688ZM15.6503 24.7467V22.569H18.3497V24.7467H15.6503Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownToken);
export default __webpack_public_path__ + "static/media/unknown_token.7f8b249f21c7e87110c0121bbcca07b7.svg";
export { ForwardRef as ReactComponent };